import { LoginForm } from './LoginForm';

export const LoginPage = () => <LoginForm />;
